import DashboardIcon from "./../assets/images/dashboard.png";
import DocumentIcon from "./../assets/images/documentIcon.png";
import HistoryIcon from "./../assets/images/historyIcon.png";
import PaymentIcon from "./../assets/images/paymentIcon.png";
import DisbursementIcon from "./../assets/images/disbursementIcon.png";
import HelpOutlineIcon from "./../assets/images/help.png";

export const ROUTES = {
  Base: {
    index: "/",
    indexReplacePath: "dashboard",
    notMatch: "*",
    notFound: "/page-not-found",
    sessionTimeout: "/session-timeout",
  },
  assisted_journey: {
    index: "/assisted-journey",
    locationPath: "/assisted-journey",
  },
  ApplyNow: {
    index: "/apply-now",
    locationPath: "/apply-now",
  },
  // login
  Login: {
    index: "/login",
    otp: {
      path: "otp",
      locationPath: "/login/otp",
    },
    register: {
      path: "register",
      locationPath: "/login/register",
    },
    thankYouPage: {
      path: "thank-you",
      locationPath: "/login/thankYouPage",
    },
    selectProfile: {
      path: "select-profile",
      locationPath: "/login/select-profile",
    },
    setPassword: {
      path: "set-password",
      locationPath: "/login/set-password",
    },
    enterPassword: {
      path: "enter-password",
      locationPath: "/login/enter-password",
    },
    forgotPassword: {
      path: "forgot-password",
      locationPath: "/login/forgot-password",
    },
    passwordCreated: {
      path: "password-created",
      locationPath: "/login/password-created",
    },
    loginType: {
      path: "login-type",
      locationPath: "/login/login-type",
    },
  },
  // dashboard
  Application: {
    index: "/assisted-portal",
    uploadDocument: {
      path: "upload-document",
      locationPath: "/assisted-portal/upload-document",
    },
    applyNow: {
      path: "apply-now",
      locationPath: "/assisted-portal/apply-now",
    },
    viewAllApplications: {
      path: "view-all-applications",
      locationPath: "/view-all-applications",
    },
    mandatoryDocuments: {
      path: "mandatory-documents",
      locationPath: "/assisted-portal/mandatory-documents",
    },
    bulkDocuments: {
      path: "bulk-documents",
      locationPath: "/assisted-portal/bulk-documents",
    },
    customerUploadDocuments: {
      path: "customer-upload-documents",
      locationPath: "/assisted-portal/customer-upload-documents",
    },
  },
  Dashboard: {
    index: "/dashboard",
    flexiTermLoan: {
      path: "flexi-term-loan",
      locationPath: "/dashboard",
      accountSummary: {
        path: "account-summary",
        locationPath: "/dashboard/account-summary",
      },
    },
    termLoanPage: {
      path: "term-loan",
      locationPath: "/dashboard/term-loan",
      requestForDisbursement: {
        path: "request-for-disbursement",
        locationPath: "/dashboard/term-loan/request-for-disbursement",
      },
      viewAllLoans: {
        path: "view-all-loans",
        locationPath: "/dashboard/term-loan/view-all-loans",
      },
      disburseMentData: {
        path: "disbursement",
        locationPath: "/dashboard/term-loan/disbursement",
      },
    },
  },
  // profile
  Profile: {
    index: "/profile",
    changePassword: {
      path: "change-password",
      locationPath: "/profile/change-password",
    },
  },
  Maintenance: {
    index: "/maintenance-page",
  },
  // notifications
  Notifications: {
    index: "/notifications",
  },
  // sidNavBarMenuOptions
  SidNavBarMenuOptions: [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: DashboardIcon,
    },
    {
      path: "",
      label: "Disbursement",
      icon: DisbursementIcon,
    },
    {
      path: "",
      label: "Payment",
      icon: PaymentIcon,
    },
    {
      path: "",
      label: "Documents",
      icon: DocumentIcon,
    },
    {
      path: "",
      label: "History",
      icon: HistoryIcon,
    },
  ],
  SideNavBarMenuFlexiOptions: [
    {
      path: "/dashboard",
      label: "Loan",
      icon: DashboardIcon,
    },
    {
      path: "",
      label: "Withdrawal",
      icon: DisbursementIcon,
    },
    {
      path: "",
      label: "Payment",
      icon: HistoryIcon,
    },
    {
      path: "",
      label: "Documents",
      icon: DocumentIcon,
    },
  ],
  // quickLinks
  QuickLinks: {
    path: "",
    label: "QuickLinks",
    icon: HelpOutlineIcon,
    QuickLinks: [
      { path: "https://www.avanse.com/disclaimer", label: "Disclaimer" },
      {
        path: "https://www.avanse.com/privacy-policy",
        label: "Privacy Policy",
      },
      {
        path: "https://www.avanse.com/terms-conditions",
        label: "Terms & Conditions",
      },
      {
        path: "https://www.avanse.com/grievance-redressal-mechanism#ombudsman-scheme",
        label: "Ombudsman Scheme",
      },
      {
        path: "https://www.avanse.com/viewPagesAssets/pdf/grievance-redressal-mechanism-2022.pdf",
        label: "Customer Complaint",
      },
    ],
  },
};
